<script lang="ts">
	import type { PublicIncident } from '../../AppTypes';
	import { formatDateTime, impactLabel } from '../../statusUtils';

	export let incident: PublicIncident;

	function statusColor(status: string): string {
		if (status === 'resolved' || status === 'completed') return 'text-green-600 dark:text-green-400';
		if (status === 'monitoring') return 'text-blue-600 dark:text-blue-400';
		return 'text-amber-600 dark:text-amber-400';
	}
</script>

<div class="border border-gray-200 dark:border-zinc-700 bg-white dark:bg-zinc-900 rounded-lg p-4">
	<div class="flex items-start justify-between gap-3">
		<div>
			<h3 class="font-semibold text-gray-900 dark:text-white">{incident.title}</h3>
			<p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
				{incident.type === 'maintenance' ? 'Maintenance' : 'Incident'} · {impactLabel(incident.impact)} impact
				{#if incident.startedAt}· {formatDateTime(incident.startedAt)}{/if}
			</p>
		</div>
		<span class="text-xs font-medium uppercase tracking-wide {statusColor(incident.status)}">{incident.status}</span>
	</div>

	{#if incident.updates && incident.updates.length > 0}
		<ol class="mt-3 border-l border-gray-200 dark:border-zinc-700 pl-4 space-y-3">
			{#each incident.updates as update}
				<li>
					<p class="text-xs font-semibold {statusColor(update.status)} uppercase">{update.status}</p>
					<p class="text-sm text-gray-700 dark:text-gray-300">{update.body}</p>
					<p class="text-xs text-gray-400 mt-0.5">{formatDateTime(update.createdAt)}</p>
				</li>
			{/each}
		</ol>
	{/if}
</div>
